module.exports = __webpack_public_path__ + "img/medium-dupa.58ebfa1f.png";